var global = require(33);

module.exports = global.Promise;
